import React, {Component} from 'react';
import {connect} from 'react-redux';
import OverviewTab from "../../components/overviewTab";
import {
    addAnotherOverviewAttachment, changeOverviewAttachment,
    changeOverviewPolicyField, getOverviewTabTagsDescription,
    overviewPolicyAttachmentsChange, removeOverviewAttachment,
    requestGetApplicationOverview, requestPostOverviewPolicyForm
} from "../../actions/overviewTab";
import _ from 'lodash';

class OverViewTabHOC extends Component {

	componentWillMount() {
		let route = this.props.router.location.pathname;
		let splitedRoute = _.split(route,'/',4);
		let splitId = splitedRoute[3];
		this.props.getApplicationOverview(splitId);
		this.props.getOverviewTabTagsDescription();
	}

	handleOverviewTabSubmit = (evt) => {
		evt.preventDefault();

		let attachment = this.props.overviewTab.attachment;
		let checkBoxesState = this.props.applicationPolicy.usersOverviewTabCheckBoxes;
		let sendBody = {};
		if(
			this.props.overviewTab.comments !== null
			&& !this.props.overviewTab.comments.trim()
			&& this.props.overviewTab.attachments
			&& this.props.overviewTab.attachments[0]
			&& this.props.overviewTab.attachments[0].attachment
			&& !this.props.overviewTab.attachments[0].attachment.name
		) {
			this.props.changeOverviewPolicyField('badMsg', 'Please, make a comment or upload a file.');
			return;
		}

		if(!checkBoxesState.all && (!checkBoxesState.arag) && (!checkBoxesState.aragAndMedicalExperts) && (this.props.user.loggedInUser.roles[0] !== 'Solicitor') ) {
			this.props.changeOverviewPolicyField('badMsg', 'Please select the comment\'s visibility.');
		}
		else {
			if (this.props.overviewTab.attachments.length === 0 ) {
				if (this.props.user.loggedInUser.roles[0] === 'Solicitor') {
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
					};
				}
				else {
					let updateCheckBoxes = {...this.props.applicationPolicy.usersOverviewTabCheckBoxes};
					let visibleBySolicitor = false;
					let visibleByMedical = false;
					if (updateCheckBoxes.all === true) {
						visibleBySolicitor = true;
						visibleByMedical = true;
					}
					else if (updateCheckBoxes.aragAndMedicalExperts === true) {
						visibleBySolicitor = false;
						visibleByMedical = true;
					}
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
							visibleBySolicitor: visibleBySolicitor,
							visibleByMedical: visibleByMedical
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
						visibleBySolicitor: visibleBySolicitor,
						visibleByMedical: visibleByMedical,
						sendEmail: this.props.overviewTab.sendEmailNotification
					};
				}
			}
			else {
				if (this.props.user.loggedInUser.roles[0] === 'Solicitor') {
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
							attachments: _.filter(this.props.overviewTab.attachments, attachment => {
								return attachment.attachment.name
							}).map(attachment => {
                                return {...attachment.attachment, tags: attachment.tags}
                            })
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                        attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                            return attachment.attachment.name
                        }).map(attachment => {
                            return {...attachment.attachment, tags: attachment.tags}
                        })
					};
				}
				else {
					let updateCheckBoxes = {...this.props.applicationPolicy.usersOverviewTabCheckBoxes};
					let visibleBySolicitor = false;
					let visibleByMedical = false;
					if (updateCheckBoxes.all === true) {
						visibleBySolicitor = true;
						visibleByMedical = true;
					}
					else if (updateCheckBoxes.aragAndMedicalExperts === true) {
						visibleBySolicitor = false;
						visibleByMedical = true;
					}
					if (this.props.overviewTab.comments === '')
						sendBody = {
							applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                            attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                                return attachment.attachment.name
                            }).map(attachment => {
                                return {...attachment.attachment, tags: attachment.tags}
                            }),
							visibleBySolicitor: visibleBySolicitor,
							visibleByMedical: visibleByMedical
						};
					else  sendBody = {
						comment: this.props.overviewTab.comments,
						applicationId: this.props.applicationsAndPolicies.selectedApplication.id,
                        attachments: _.filter(this.props.overviewTab.attachments, attachment => {
                            return attachment.attachment.name
                        }).map(attachment => {
                        	return {...attachment.attachment, tags: attachment.tags}
						}),
						visibleBySolicitor: visibleBySolicitor,
						visibleByMedical: visibleByMedical,
						sendEmail: this.props.overviewTab.sendEmailNotification
					};
				}
			}
			this.props.postOverviewPolicyForm(sendBody);
		}
	};


	onDropOverview = (files, attachmentIndex) => {
		files.map((file) => {
			let reader = new FileReader();
			reader.readAsDataURL(file);
			let attachment = {
				name: file.name,
				encodedFile: '',
				fileType: file.type
			};
			let props = this.props;
			reader.onload = function () {
				attachment = {
					...attachment,
					encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)
				};
				props.changeOverviewAttachment({
					value: attachment,
					key: 'attachment',
					attachmentIndex: attachmentIndex
				})
			};
			reader.onerror = function (error) {
				console.log('Error: ', error);
			};
		})
	};

	calculateFeaturedOverview = () => {
		let overviews = [...this.props.overviewTab.applicationOverview];
		let page = this.props.overviewTab.page;
		let selectedView = 10;
		//initialize featured overviews
		let featuredOverviews = overviews;

		//calculation of the overviews per page
		let start = (page - 1) * selectedView;
		let end = start + selectedView;
		let featuredOverviewsPerPage = featuredOverviews.slice(start, end);

		return [featuredOverviewsPerPage, featuredOverviews.length];
	};

	render() {
		return (
			<OverviewTab
                changeOverviewAttachment={this.props.changeOverviewAttachment}
                removeOverviewAttachment={this.props.removeOverviewAttachment}
                addAnotherOverviewAttachment={this.props.addAnotherOverviewAttachment}
				applicationStatus={this.props.applicationStatus}
				ApplicationPolicyStore={this.props.ApplicationPolicyStore}
				CheckUserOverviewTabCheckBox={this.props.CheckUserOverviewTabCheckBox}
				UserRole={this.props.UserRole}
				PageShift={this.props.PageShift}
				CalculateFeaturedOverview={this.calculateFeaturedOverview}//
				ChangeOverViewTabReadMoreState={this.props.ChangeOverViewTabReadMoreState}
				RowData={[]}
				Label="overview"
				HandleInputChange={this.props.HandleInputChange}
				handleSubmit={this.handleOverviewTabSubmit}//
				overviewTab={this.props.overviewTab}
				OnDrop={this.onDropOverview}
				selectedApplication = {this.props.applicationsAndPolicies.selectedApplication}
				requestApplicationAttachment = {this.props.requestApplicationAttachment}
			/>
		)
	}

}

const mapStateToProps = (state) => {
	return {
		overviewTab: state.overviewTab,
		router: state.router,
		applicationPolicy: state.applicationPolicy,
		applicationsAndPolicies: state.applicationsAndPolicies,
		user: state.user
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getApplicationOverview: (id) => {
			dispatch(requestGetApplicationOverview(id))
		},
		updateOverviewPolicyAttachmentsChange: (attachment) => {
			dispatch(overviewPolicyAttachmentsChange(attachment))
		},
		postOverviewPolicyForm: (sendBody) => {
			dispatch(requestPostOverviewPolicyForm(sendBody))
		},
		changeOverviewPolicyField: (field, value) => {
			dispatch(changeOverviewPolicyField(field, value))
		},
        getOverviewTabTagsDescription: () => {
			dispatch(getOverviewTabTagsDescription())
		},
        addAnotherOverviewAttachment: (payload) => {
			dispatch(addAnotherOverviewAttachment(payload))
		},
        removeOverviewAttachment: (payload) => {
			dispatch(removeOverviewAttachment(payload))
		},
        changeOverviewAttachment: (payload) => {
			dispatch(changeOverviewAttachment(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(OverViewTabHOC);
